import createReactComponent from '../createReactComponent';
export default createReactComponent('zero', 'Zero', [["path",{"d":"M8.75 13.875v-3.75a3.125 3.125 0 1 1 6.25 0v3.75a3.125 3.125 0 1 1-6.25 0","key":"svg-0"}]]);